import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { postWithAuth, getWithAuth } from "../../../api/api";
import { API_URLS } from "../../../api/apiConfig";

const ModalNewUser = ({ onClose }) => {
  const [showAlert, setIshowAlert] = useState(false);
  const [alertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // selector de rol
  const [roles, setRoles] = useState([]);
  const [isLoadingRoles, setIsLoadingRoles] = useState(false);
  const [rolesError, setRolesError] = useState("");

  const [newUser, setUser] = useState({
    username: "",
    name: "",
    last_name: "",
    email: "",
    temporal_password: "",
    role_id: "", // <- importante para el selector de rol
  });

  useEffect(() => {
    const fetchRoles = async () => {
      setIsLoadingRoles(true);
      setRolesError("");
      try {
        const resp = await getWithAuth(API_URLS.GET_ROLES);
        if (resp.message === "success") {
          setRoles(resp.data || []);
        } else {
          setRolesError(resp.detail || "No se pudieron cargar los roles");
        }
      } catch (e) {
        console.error("Error fetching roles:", e);
        setRolesError("Ha ocurrido un error cargando los roles");
      } finally {
        setIsLoadingRoles(false);
      }
    };
    fetchRoles();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setUser((prev) => {
      const updated = {
        ...prev,
        [name]: type === "checkbox" ? !prev[name] : value,
      };
      if (name === "email") {
        updated.username = value; // sincroniza username con email
      }
      return updated;
    });
  };

  const saveUser = async () => {
    try {
      setIsLoading(true);
      const response = await postWithAuth(API_URLS.NEW_USER, newUser);
      if (response.message === "success") {
        setIsLoading(false);
        window.location.reload();
      } else {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage(response.detail || "Error inesperado");
      }
    } catch (error) {
      console.error("Error creating user admin:", error);
      setIsLoading(false);
      setIshowAlert(true);
      setShowAlertMessage("Error conectando con el servidor");
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // validaciones simples
    if (
      !newUser.name ||
      !newUser.last_name ||
      !newUser.email ||
      !newUser.temporal_password
    ) {
      setIshowAlert(true);
      setShowAlertMessage("Rellena todos los campos obligatorios.");
      return;
    }
    if (!newUser.role_id) {
      setIshowAlert(true);
      setShowAlertMessage("Selecciona un rol para el usuario.");
      return;
    }

    await saveUser();
  };

  return (
    <>
      <Modal show={true} onHide={onClose} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Nuevo usuario</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            className="form fv-plugins-bootstrap5 fv-plugins-framework"
            action="#"
          >
            <div className="modal-body py-10 px-lg-17">
              <div
                className="scroll-y me-n7 pe-7"
                id="kt_modal_create_api_key_scroll"
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#kt_modal_create_api_key_header"
                data-kt-scroll-wrappers="#kt_modal_create_api_key_scroll"
                data-kt-scroll-offset="300px"
              >
                {showAlert && (
                  <div className="alert alert-danger d-flex align-items-center p-5">
                    <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4"></i>
                    <div className="d-flex flex-column">
                      <span className="mb-1 text-danger">{alertMessage}</span>
                    </div>
                  </div>
                )}

                <div className="row g-9 mb-8">
                  <div className="col-md-6 fv-row">
                    <label className="required fs-6 fw-semibold mb-2">
                      Nombre
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      name="name"
                      value={newUser.name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row">
                    <label className="required fs-6 fw-semibold mb-2">
                      Apellidos
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      name="last_name"
                      value={newUser.last_name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="row g-9 mb-8">
                  <div className="col-md-6 fv-row">
                    <label className="required fs-6 fw-semibold mb-2">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-solid"
                      name="email"
                      value={newUser.email}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row">
                    <label className="required fs-6 fw-semibold mb-2">
                      Contraseña Temporal
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      name="temporal_password"
                      value={newUser.temporal_password}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                {/* Selector de rol */}
                <div className="row g-9 mb-8">
                  <div className="col-md-6 fv-row">
                    <label className="required fs-6 fw-semibold mb-2">
                      Rol
                    </label>
                    <select
                      className="form-select form-select-solid"
                      name="role_id"
                      value={newUser.role_id}
                      onChange={handleInputChange}
                      disabled={isLoadingRoles}
                    >
                      <option value="">
                        {isLoadingRoles
                          ? "Cargando roles..."
                          : "Selecciona un rol"}
                      </option>
                      {roles.map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.name} {r.description ? `— ${r.description}` : ""}
                        </option>
                      ))}
                    </select>
                    {rolesError && (
                      <div className="text-danger mt-2">{rolesError}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer flex-center">
              <button
                type="button"
                id="kt_modal_create_api_key_cancel"
                className="btn btn-light me-3"
                onClick={onClose}
                disabled={isLoading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                onClick={handleSave}
                className="btn btn-primary"
                data-kt-indicator={isLoading ? "on" : "off"}
                disabled={isLoading}
              >
                <span className="indicator-label">Crear usuario</span>
                <span className="indicator-progress">
                  Creando...
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalNewUser;
